import { render, staticRenderFns } from "./VInputSearch.vue?vue&type=template&id=cff6a962&scoped=true&"
import script from "./VInputSearch.vue?vue&type=script&lang=js&"
export * from "./VInputSearch.vue?vue&type=script&lang=js&"
import style0 from "./VInputSearch.vue?vue&type=style&index=0&id=cff6a962&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff6a962",
  null
  
)

export default component.exports